import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  Badge,
} from '@vnetwork/ui/primitives';
import type { CustomerJourney } from '@/api/customer-journey';
import { formatDate } from '@/lib/format';
import { statusTone, outcomeLabel, stepLabel } from './sale-process-helpers';

/**
 * Active-journey picker shown when a customer has more than one journey. Each
 * option is labelled by id + current step; the selected journey's status badge
 * and created date render alongside.
 */
export function JourneySelector({
  journeys,
  activeJourneyId,
  onSelect,
}: {
  journeys: CustomerJourney[];
  activeJourneyId: number;
  onSelect: (journeyId: number) => void;
}) {
  const active = journeys.find((j) => j.customer_journey_id === activeJourneyId);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 'var(--vn-space-3)' }}>
      <Select value={String(activeJourneyId)} onValueChange={(v) => onSelect(Number(v))}>
        <SelectTrigger style={{ minWidth: 280 }}>
          <SelectValue placeholder="Select journey" />
        </SelectTrigger>
        <SelectContent>
          {journeys.map((j) => (
            <SelectItem key={j.customer_journey_id} value={String(j.customer_journey_id)}>
              #{j.customer_journey_id} · {stepLabel(j.customer_journey_step)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {active ? (
        <>
          <Badge tone={statusTone(active)} appearance="subtle" size="sm">
            {outcomeLabel(active)}
          </Badge>
          <span style={{ fontSize: 'var(--vn-font-size-sm)', color: 'var(--vn-fg-muted)' }}>
            Created {formatDate(active.customer_journey_created_at)}
          </span>
        </>
      ) : null}
    </div>
  );
}

export default JourneySelector;
